export default __webpack_public_path__ + "static/media/curved_arrow.5c73f5ed.svg";